
import React, { Component } from "react";
import "./BankTransferForm.css";
import { BankData } from "../Data/BankData";
import { t } from "i18next";

class SelectedImageNew extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedAccount: null,
      bankData: BankData,
      dropdownOpen: false,
    };
    this.dropdownRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (
      this.dropdownRef.current &&
      !this.dropdownRef.current.contains(event.target)
    ) {
      this.setState({ dropdownOpen: false });
    }
  };

  toggleDropdown = () => {
    this.setState((prevState) => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
  };

  handleSelectAccount = (account) => {
    const { onChangBank } = this.props;
    if (onChangBank) {
      this.setState(
        {
          selectedAccount: account,
          dropdownOpen: false,
        },
        () => {
          onChangBank(account);
          this.getBankLogo(account.bank_id);
        }
      );
    }
  };

  getBankLogo = (bankCode) => {
    const bank = this.state.bankData.find(
      (b) => b.bank_id === bankCode || b.bankCode === bankCode
    );
    return bank ? bank.bankLogo : "";
  };

  render() {
    const { selectedAccount, bankData, dropdownOpen } = this.state;
   
    return (
      <div className="bank-transfer-bank">
        <div className="">
          <div className="custom-dropdown" ref={this.dropdownRef}>
            <div className="dropdown-selected" onClick={this.toggleDropdown}>
              {selectedAccount ? (
                <>
                  <img
                    src={selectedAccount?.bankLogo}
                    alt="Bank Logo"
                    className="bank-logo-small"
                  />
                  <span>{t(selectedAccount?.bank_id)}</span>
                </>
              ) : (
                "-- เลือก --"
              )}
              <span className="dropdown-arrow"></span>
            </div>
            {dropdownOpen && (
              <div className="dropdown-options">
                {bankData.map((bank, index) => (
                  <div
                    key={index}
                    className={`dropdown-option ${
                      bank?.bank_id === selectedAccount?.bank_id
                        ? "selected"
                        : ""
                    }`}
                    onClick={() => this.handleSelectAccount(bank)}
                  >
                    <img
                      src={this.getBankLogo(bank?.bank_id)}
                      alt="Bank Logo"
                      className="bank-logo-small"
                    />
                    <span>
                      {bank?.bankNameTH} ({bank?.bank_id})
                      {bank?.bank_id === selectedAccount?.bank_id
                        ? " ( Selected )"
                        : ""}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default SelectedImageNew;
